import { CommissionReleases } from '@core/models/commission-releases.model';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Injectable } from '@angular/core';

@Injectable()
export class CommissionReleasesEntityService extends EntityCollectionServiceBase<CommissionReleases> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
      super('CommissionReleases', serviceElementsFactory);
  }
}